export default {
  // DASHBOARD
  DASHBOARD_TOGGLE: 'me-dashboard:toggle',
  DASHBOARD_REFRESH: 'me-dashboard:refresh',

  ME_SHIFT_FORM_UPDATE: 'me:shift-form:update',

  // CALENDAR
  ME_CALENDAR_REFRESH: 'me-calendar:refresh',

  // LEAVE
  LEAVE_ADD_SUCCESS: 'leave:add-success',
  LEAVE_ADD_ERROR: 'leave:add-error',
  LEAVE_CANCEL_SUCCESS: 'leave:cancel-success',
  LEAVE_CANCEL_ERROR: 'leave:cancel-error',
};
